<script setup>
  import Modal from "../../../../../components/ui-components/modal/Modal.vue";
  import { ref, defineExpose, getCurrentInstance } from "vue";
  import { useRouter } from 'vue-router'
  import {usePageLoadingStore} from "../../../../../stores/pageLoading";
  import {useUserStore} from "@/pages/user/stores/user";
  import { storeToRefs } from "pinia";
  import Loading from 'vue3-loading-overlay';
  import MyPageResumeModalBody from "../mypage/MyPageResumeModalBody.vue";
  import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
  import mypageJobFairResumeService from "../../../services/mypage/jobFair/mypageJobFairResumeService";
  import mypageJobFairService from "../../../services/mypage/jobFair/mypageJobFairService";
  import JobFairIntvProposalJobNoticeListModal from "./JobFairIntvProposalJobNoticeListModal.vue";

  const router = useRouter();
  const loadingStore = usePageLoadingStore()

  const userStore = useUserStore(); // 사용자 정보
  const { user } = storeToRefs(userStore);

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { alert, confirm } = globals;

  const baseModal = ref(null);
  const resolvePromise = ref(null);

  const modalBody = ref(null);
  const intvProposalJobNoticeListModal = ref([]); // 채용공고 목록 팝업

  const loaded = ref(false);

  const resumeLikeTxts = ref("♡관심인재");
  const disabledCorpYns = ref(false);
  const interestYns = ref(0);
  const showDeleteBtns = ref(false);
  const hideFooterBtns = ref(false); // 하단 버튼 숨김 여부 추가
  const _from = ref('');
  const resumeIds = ref(0);
  const jobNoticeSeqs = ref(null);

  const resumeDetail = ref(null); // 이력서 상세조회 데이터

  const retrieveResumeDetail = (resumeId) => {
    resumeIds.value = resumeId;
    loaded.value = false;

    // 
    mypageJobFairResumeService.retrieveResume(resumeId)
      .then( (res) => {
        loaded.value = true;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          modalBody.value.setHidden(0);
          modalBody.value.setRecord(result);
          resumeDetail.value = result;
        }
      })
      .catch( (error) =>  {
        loaded.value = true;
      });
  }

  const retrieveCorpInterestHallEntryYn = (resumeId) => {
    mypageJobFairService.retrieveCorpInterestHallEntryYn(resumeId)
      .then( (res) => {
        loaded.value = true;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          interestYns.value = result;
          if(interestYns.value === 'N') {
            resumeLikeTxts.value = "♡관심인재";
          } else {
            resumeLikeTxts.value = "♥관심인재";
          }
        }
      })
      .catch( (error) =>  {
        loaded.value = true;
      });
  }

  // 마이페이지 > 상시채용관 현황 > [탭] 이력서 관림치 입사지원 현황 이동
  const onClickManageResume = () => {
    router.push({ name: 'MyPageJobFair', query : { tab: 'resume'}})
  }
  
  // 이력서 수정 버튼. 새창으로 열기
  const onClickEditResume = () => {
    router.push({ name: 'MyPageJobFairResume', query : { resumeId: resumeIds.value, jobNoticeSeq: jobNoticeSeqs.value }})
  }

  // 이력서 선택 
  const onClickConfirmResume = async () => {
    const ok = await confirm(["선택한 이력서로", "입사 지원 하시겠습니까?"], "입사지원", "아니오");
    if(ok) {
      cancel({
        resumeId: resumeIds.value,
      });
    } else {
      cancel();
    }
  }

  // 이력서 삭제
  const onClickDeleteResume = async () => {
    let modalContent = [];
    if (resumeDetail.value.resOpenYn === "Y") {
      modalContent = ["인재정보에 공개된 이력서 입니다.", "그래도 이력서를 삭제하시겠습니까?"];
    } else {
      modalContent = ["이력서를 삭제하시겠습니까?"];  
    }

    const ok = await confirm(modalContent, "삭제", "취소");
    if(ok) {
      mypageJobFairResumeService.deleteResume({ resumeId: resumeIds.value })
        .then(async (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            if(resumeDetail.value.resOpenYn === "Y") {
              await alert( ["이력서가 삭제되었습니다.", "인재정보에 공개할 이력서를 다시 선택하세요."]);
              baseModal.value.close();
              resolvePromise.value(false);
            } else {
              await alert( ["이력서가 삭제되었습니다."]);
              baseModal.value.close();
              resolvePromise.value(false);
            }
          }
        })
        .catch( (res) =>  {
          loaded.value = true;
          alert([res.response.data.result.message]);
        });
    }
  }

  // 관심인재
  const onClickResumeLikeYn = async () => {
    let modalContent, okButtonText;
    let targetInterestYns = '';

    if(interestYns.value === 'Y') {
      targetInterestYns = 'N';
      modalContent = ["관심인재를 삭제하시겠습니까?"];
      okButtonText = "관심인재 삭제";
    } else {
      targetInterestYns = 'Y';
      modalContent = ["관심인재를 등록하시겠습니까?"];
      okButtonText = "관심인재 등록"; 
    }
    const ok = await confirm(modalContent, okButtonText);
    if(ok) {
      const paramObj = {
        resumeId: resumeIds.value,
        interestYn: targetInterestYns,
      };

      mypageJobFairService.updateCorpInterestHallEntryYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;

            interestYns.value = targetInterestYns;
            alert(`${interestYns.value === 'N' ? '삭제' : '등록'}하였습니다.`);
            if(interestYns.value === 'N') {
              resumeLikeTxts.value = "♡관심인재";
            } else {
              resumeLikeTxts.value = "♥관심인재";
            }
          } else {
            alert(["변경을 실패하였습니다."]);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          alert(["변경을 실패하였습니다."]);
        });
    }
  }

  // 면접제안
  const onClickInterviewProposal = async () => {
    const result = await intvProposalJobNoticeListModal.value.show({
      corpId: user?.value?.userInfo?.corporation?.corpId || '',
      resumeId: resumeIds.value,
    });

    if(result && result.jobNoticeSeq) {
      const paramObj = {
        resumeId: resumeIds.value,
        jobNoticeSeq: result.jobNoticeSeq,
      };

      loadingStore.loading = true;
      mypageJobFairService.createInterviewProposalEntry(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert(["면접제안을 하였습니다."]);
          } else {
            alert(["면접제안을 실패하였습니다."]);
          }
        })
        .catch( (error) =>  {
          alert(["면접제안을 실패하였습니다."]);
          loadingStore.loading = false;
        }); 
    }
  }

  const show = ({ jobNoticeSeq,resumeId, interestYn, showDeleteBtn, from, hideFooterBtn }) => {
    if(resumeId) {  
      retrieveResumeDetail(resumeId);
      if(user.value?.userGb !== 'STUDENT') {
        if (!hideFooterBtn) {
          retrieveCorpInterestHallEntryYn(resumeId);
        }
      }

      hideFooterBtns.value = hideFooterBtn;
      resumeIds.value = resumeId;
    }

    if(jobNoticeSeq) {
      jobNoticeSeqs.value = jobNoticeSeq;
    }

    // 관심인재
    if(interestYn === 'Y') {
      resumeLikeTxts.value = "♥관심인재";
    } else {
      resumeLikeTxts.value = "♡관심인재";
    }
    interestYns.value = interestYn;
    // gnbResumes.value = gnbResume; // gnb 인재정보에서 이력서 볼 때 삭제 버튼 숨기기 위한 데이터
    // joinStateGbs.value = joinStateGb; // 행사 상태 구분 (삭제 버튼 관리)
    // applicantCnts.value = applicantCnt; // 입사지원 이력 0: 입사지원 X (삭제 버튼 관리)
    // intvProposalCnts.value = intvProposalCnt; // 받은 면접제안 수락/거절 수 0이 아닐 경우 수정,삭제 버튼 노출 X

    if(showDeleteBtn) {
      showDeleteBtns.value = showDeleteBtn;
    }

    _from.value = from;
    if(_from.value === 'JobFairCorpApplicantResumeSelectModal') {
      showDeleteBtns.value = true;
    }

    baseModal.value.open();
    return new Promise((resolve, _) => {
      resolvePromise.value = resolve;
    });
  };

  const _confirm = async () => {
    baseModal.value.close();
    resolvePromise.value(true);
  };

  const cancel = (result) => {
    baseModal.value.close();
    resolvePromise.value({
      ...result,
      interestYn: interestYns.value,
    });
  };

  defineExpose({
    show,
  })
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded">
        <MyPageResumeModalBody ref="modalBody"/>
      </div>
      <template v-if="!hideFooterBtns">
        <div v-if="user.userGb === 'STUDENT' && user.userInfo?.userCd === resumeDetail?.userId" class="modal-footer">
          <div v-if="!showDeleteBtns" style="width: 100%; padding: 0; text-align: right;">
            <div>
              <KSAPrimaryButton text="이력서 관리" @click="onClickManageResume()" />
            </div>
          </div>
          <div v-else style="width: 100%; padding: 0">
            <div v-if="_from === 'JobFairCorpApplicantResumeSelectModal'" class="modal-footer btn-wrap" style="width: 100%; padding: 0">
              <KSASecondaryButton text="수정" class="" @click="onClickEditResume()" :disabled="resumeDetail.applicantCnt > 0" />
              <KSAPrimaryButton text="선택" @click="onClickConfirmResume()" />
            </div>
            <div v-else class="modal-footer btn-wrap" style="width: 100%; padding: 0">
                <KSASecondaryButton text="삭제" class="red_button" @click="onClickDeleteResume()" :disabled="resumeDetail.applicantCnt > 0" />
                <KSAPrimaryButton text="수정" @click="onClickEditResume()" :disabled="resumeDetail.applicantCnt > 0" />
            </div>
          </div>
        </div>
        <div v-else-if="user.userGb === 'COMPANY' && user.userInfo?.corpMasterYn === 'Y'" class="modal-footer btn-wrap">
          <span data-title="관심인재 : ">
            <KSASecondaryButton :text="resumeLikeTxts" @click="onClickResumeLikeYn()" class="red_button"/>
          </span>
          <span data-title="면접제안 : ">
            <KSAPrimaryButton text="면접제안" :disabled="disabledCorpYns" @click="onClickInterviewProposal()" />
          </span>
        </div>
      </template>
    </div>
  </Modal>
  <JobFairIntvProposalJobNoticeListModal ref="intvProposalJobNoticeListModal" />
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>